import Reveal from '@/components/base/Reveal';
import { timeline } from '@/mocks/about';

export default function Timeline() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            The Journey
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            How the Strategy Took Shape
          </h2>
          <p className="mt-4 text-foreground-600">
            From hands-on digital marketing to building a business around growth systems.
          </p>
        </Reveal>

        <div className="mt-14 relative">
          <div className="absolute left-[7px] top-0 bottom-0 w-px bg-gradient-to-b from-primary-500/50 via-white/10 to-transparent" />

          <div className="space-y-8">
            {timeline.map((t, i) => (
              <Reveal key={t.year} delay={i * 80}>
                <div className="relative pl-8 md:pl-10">
                  <span className="absolute left-0 top-2 w-4 h-4 rounded-full bg-primary-500 ring-4 ring-primary-500/15" />
                  <div className="rounded-xl border border-white/8 bg-background-100 p-6">
                    <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold whitespace-nowrap">
                      {t.year}
                    </span>
                    <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">
                      {t.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}